import { Model } from '@vuex-orm/core'

export default class Note extends Model {
  // This is the name used as module name of the Vuex Store.
  static entity = 'notes'

  static primaryKey = '_id'

  // List of all fields (schema) of the post model. `this.attr` is used
  // for the generic field type. The argument is the default value.
  static fields () {
    return {
      _id: this.attr(null),
      note: this.attr(null),
      mention_users: this.attr(null)
    }
  }
}



// WEBPACK FOOTER //
// ./src/models/Note.js